import type { PromoFetcher } from "@engine/net/PromoFetcher";
import type { IImprintData } from "@engine/types";
import commitmentFallback from "@config/content/commitment_fallback.json";
import promosFallback from "@config/content/promos_fallback.json";
import privacyFallback from "@config/content/privacy_fallback.json";
import gameInfo from "@config/game_info.json";

/**
 * Wraps engine PromoFetcher with the imprint's live endpoints + bundled fallback.
 *
 * Data-driven from config/game_info.json — no per-game code changes required.
 * Popphin Learning imprint mirrors JSONs from popphin.com to billybisson.com at build time
 * so both games' runtime fetches stay same-origin.
 */
export class PromoManager {
  constructor(private readonly fetcher: PromoFetcher) {
    const bundledFallback: IImprintData = {
      commitment: commitmentFallback,
      promos: promosFallback,
      privacy: privacyFallback
    };
    const host = gameInfo.imprintDomain;
    this.fetcher.configure({
      commitmentUrl: `https://${host}/_data/commitment.json`,
      promosUrl: `https://${host}/_data/promos.json`,
      privacyUrl: `https://${host}/_data/privacy.json`,
      bundledFallback
    });
  }

  async revalidate(): Promise<void> {
    await this.fetcher.revalidate();
  }

  current(): IImprintData {
    return this.fetcher.current();
  }
}
